import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const LazyAddPersonalSpaceDialog: LoadableType<any> = LoadableAfterPaint<any>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AddPersonalSpaceDialog" */ './AddPersonalSpaceDialog.js'
			)
		).AddPersonalSpaceDialog,
});
